import { IEntitySchemaDefinition } from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

const Fieldset = ui.S9Fieldset.default;

const S9PageSection = ui.S9PageSection.default;

type Props = {
  schema: IEntitySchemaDefinition | undefined;
};
const ApplicationForm = ({ schema }: Props) => {
  const fields = [
    {
      field: 'organisation_id',
      colSize: 12,
    },
    {
      field: 'country',
      colSize: 12,
    },
    {
      field: 'certification_number',
      colSize: 8,
    },
    {
      field: 'partner_id',
      colSize: 16,
    },
    {
      field: 'organisation_size',
      colSize: 6,
    },
    {
      field: 'submitted_by_id',
      colSize: 6,
    },
    {
      field: 'submitted_dt',
      colSize: 6,
    },
    {
      field: 'award_dt',
      colSize: 6,
    },
    {
      field: 'expiry_dt',
      colSize: 6,
    },
  ];

  const paymentFields = [
    {
      field: 'payment_status',
      colSize: 6,
    },
    {
      field: 'payable_amount',
      prefix: '$',
      colSize: 6,
    },
    {
      field: 'promo_code',
      colSize: 6,
    },
    {
      field: 'payment_reference',
      colSize: 6,
    },
    {
      field: 'payment_dt',
      colSize: 6,
    },
    {
      field: 'payment_gateway_response',
    },
  ];

  const assessorFields = [
    {
      field: 'assessed_by_id',
      colSize: 12,
    },
    {
      field: 'request_info_dt',
      colSize: 12,
    },
    {
      field: 'request_info_assessor_note',
    },
  ];

  return (
    <>
      {schema && (
        <>
          <S9PageSection title="" size="sm">
            <Fieldset
              context={{ id: undefined }}
              schema={schema}
              formFields={fields}
            />
          </S9PageSection>
          <S9PageSection title="Payment details" size="sm">
            <Fieldset
              context={{ id: undefined }}
              schema={schema}
              formFields={paymentFields}
            />
          </S9PageSection>
          <S9PageSection title="Assessor details" size="sm">
            <Fieldset
              context={{ id: undefined }}
              schema={schema}
              formFields={assessorFields}
            />
          </S9PageSection>
        </>
      )}
    </>
  );
};

export default ApplicationForm;
